export const isMed = subjectCode => subjectCode === '00';
